import ArtikelData from "./artikel_data"

export default class NachbestellenInsertRequest {
  id: string
  bestellungId: string
  artikel: ArtikelData[] = []
  kommentare: string
}
